export const InventoryDefaultQueryParams = "resourceStatus:active";
export const ViolationsDefaultQueryParams = "violationStatus:open ruleTag:generalAvailability";
export const HygieneDefaultQueryParams = "violationStatus:open resourceStatus:active ruleTag:generalAvailability";
export const PlaybooksQueryParams = "playbookStatus:active";
